import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {employeesTableReady,rowsPerPageState,searchTextState,paginationState,employeesIdForAction,employeesPriviousFilterCity,employeesPriviousFilterDepartment,employeesPriviousFilterReportingManager,employeeDataResourceForAction} from '../redux/employees'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'

import {teamEmployeeIdForAction,attritionSourceAction} from '../../Teams/redux/teams'

import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/employeesTable.css'
import CollapsibleRow from './CollapsibleRow'
import { ImportEmployees, PermanentEmployee } from './ActionButtons'


import {Cities,Departments,Employees} from './DropDowns/index'

import * as Helpers from '../../../common/helpers'


function filterUnwantedData(employeesData) {
    let array = []
    if (employeesData && employeesData.data && employeesData.data.list) {
        array = employeesData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.name = lineData.name ? lineData.name : "NA"
            newLineData.code = lineData.code ? parseInt(lineData.code,10) : "NA"
            newLineData.designation_name=lineData.designation && lineData.designation.name ? lineData.designation.name : "NA"
            newLineData.mobile =lineData.mobile ? lineData.mobile : "NA"
            newLineData.email =lineData.email ? lineData.email : "NA"
            newLineData.category =lineData.category ? lineData.category : "NA"
            newLineData.department_name =lineData.department && lineData.department.name ? lineData.department.name : "NA"
            newLineData.reporting_manager_name =lineData.reporting_manager && lineData.reporting_manager.name ? lineData.reporting_manager.name : "NA"
            newLineData.city_name =lineData.city && lineData.city.name ? lineData.city.name : "NA"
            newLineData.email =lineData.email ? lineData.email : "NA"
            newLineData.status =lineData.status ? lineData.status : "NA"

            newLineData.work_location=""

            if(lineData.office_work_location && lineData.office_work_location.name && lineData.office_work_location.name!="" && lineData.office_work_location.name!=undefined){
                newLineData.work_location=lineData.office_work_location.name
            }

            if(lineData.kitchen_work_location && lineData.kitchen_work_location.name && lineData.kitchen_work_location.name!="" && lineData.kitchen_work_location.name!=undefined){
                newLineData.work_location=lineData.kitchen_work_location.name
            }



            let employees_users = []
            for (let j = 0; j < lineData.users.length; j++) {

                let user_roles=[];

                 for (let k = 0; k < lineData.users[j].user_roles.length; k++) {
                        user_roles.push(lineData.users[j].user_roles[k].role.name)
                 }
                employees_users[j]={
                    "user_id":lineData.users[j].id,
                    "username":lineData.users[j].username,
                    "user_type":lineData.users[j].user_type,
                    "user_roles":user_roles.join(", ")
                    }                    
            }   
            newLineData.employees_users=employees_users;

            newArray[i] = newLineData
        }
    }

    return newArray
}


class EmployeesTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            employeesData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: "",
            filter_cityId:0,
            filter_departmetnId:0,
            filter_reportingMangerId:0,
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(employeesTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.EMPLOYEES_TABLE))

        this.props.dispatch(subHeaderDataUpdate())

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()
            
            let filter_cityId=0
            let filter_departmetnId=0
            let filter_reportingMangerId=0

         if (this.props.employees && this.props.employees.previousFilterCity && this.props.employees.previousFilterCity!==undefined) {
            filter_cityId=this.props.employees.previousFilterCity
         }

          if (this.props.employees && this.props.employees.previousFilterDepartment && this.props.employees.previousFilterDepartment!==undefined) {
            filter_departmetnId=this.props.employees.previousFilterDepartment
         }

          if (this.props.employees && this.props.employees.previousFilterReportingManager && this.props.employees.previousFilterReportingManager!==undefined) {
            filter_reportingMangerId=this.props.employees.previousFilterReportingManager
         }
         this.setState({
              filter_cityId:filter_cityId,
              filter_departmetnId:filter_departmetnId,
              filter_reportingMangerId:filter_reportingMangerId
         },() => {
            this.getEmployeesData();
        });

        
        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
    getEmployeesData = () => {
        apiService.getEmployeesData(this.state.filter_cityId,this.state.filter_departmetnId,this.state.filter_reportingMangerId)
            .then(responseData => {
                if (responseData && this.isComponentMounted) {
                    this.validateBuildNumber(responseData)
                    if (responseData.status === "SUCCESS") {
                        let array = filterUnwantedData(responseData), pageNo = 1
                        if (this.props.employees && this.props.employees.previousPaginationValue) {
                            pageNo = this.props.employees.previousPaginationValue
                        }
                        this.setState({
                            employeesData: array,
                            page: pageNo,
                        })
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(employeesTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(employeesTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.employees && this.props.employees.previousRowsPerPageValue) {
            value = this.props.employees.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }


   cityChange = (data) => {
        

        if(data.value==="" || data.value===undefined){
             this.props.dispatch(employeesPriviousFilterCity(""))
             this.setState({
                filter_cityId:""
            })
        }else{
            this.props.dispatch(employeesPriviousFilterCity(data.value))
            this.setState({
                filter_cityId:data.value
            })
        }
    }



   departmentChange = (data) => {
        
         if(data.value==="" || data.value===undefined){
             this.props.dispatch(employeesPriviousFilterDepartment(""))
             this.setState({
                filter_departmetnId:""
            })
        }else{
            this.props.dispatch(employeesPriviousFilterDepartment(data.value))
            this.setState({
                filter_departmetnId:data.value
            })
        }
    }

    reportingManagerChange = (data) => {
        
        if(data.value==="" || data.value===undefined){
             this.props.dispatch(employeesPriviousFilterReportingManager(""))
             this.setState({
                filter_reportingMangerId:""
            })
        }else{
            this.props.dispatch(employeesPriviousFilterReportingManager(data.value))
            this.setState({
                filter_reportingMangerId:data.value
            })
        }
    }

    


   

    createCustomToolBar = props => {
        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">
                   {(() =>{

    if(Helpers.checkPrivileges("/dashboard/employees/addEdit",this.props.user)){
        return(

                   <div className="col-md-1 col-sm-12 col-xs-12 div-margins">
                   <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                e.preventDefault()
                                this.props.dispatch(employeesIdForAction(null))
                                this.props.history.push("/dashboard/employees/addEdit")
                            }}>
                            Add
                        </button>

                        
                    </div>
                    )
        }
})()}


                    <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                    <div className="form-group">
                            <Cities cityChange={this.cityChange} selectedValue={this.state.filter_cityId} />    
                        </div>
                    </div>
                     <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                    <div className="form-group">
                            <Departments departmentChange={this.departmentChange} selectedValue={this.state.filter_departmetnId} />    
                        </div>
                    </div>
                     <div className="col-md-3 col-sm-12 col-xs-12 div-margins"> 

                    <div className="form-group">
                            <Employees reportingManagerChange={this.reportingManagerChange} selectedValue={this.state.filter_reportingMangerId} />    
                        </div>
                    </div>
                   <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                        <button className="btn btn-primary button-custom"
                            onClick={(e) => {
                                e.preventDefault()
                                this.getFilteredEmployeesList()
                            }}>
                            Go
                        </button>
                        <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                this.resetFilterValues()
                            }}>
                            Clear
                        </button>
                    </div>
                     {(() =>{
        if(Helpers.checkPrivileges("/dashboard/employees/import",this.props.user)){
                return(
                        <div className="col-md-1 col-sm-12 col-xs-12 div-margins">
                           <ImportEmployees/>
                        </div>
                        )
                    }
                })()}
                     


                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.employeesData.length>=(this.props.employees.previousPaginationValue*this.props.employees.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.employees.previousPaginationValue*this.props.employees.previousRowsPerPageValue)-this.props.employees.previousRowsPerPageValue+1} to {this.props.employees.previousPaginationValue*this.props.employees.previousRowsPerPageValue} of {this.state.employeesData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.employees.previousPaginationValue*this.props.employees.previousRowsPerPageValue)-this.props.employees.previousRowsPerPageValue+1} to {this.state.employeesData.length} of {this.state.employeesData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }


    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))

        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

     getFilteredEmployeesList = () => {
       
        this.props.dispatch(employeesTableReady(false))
        this.resetSearchAndPagination()
        this.getEmployeesData()
       
    }

    


     resetFilterValues = () => {
        this.props.dispatch(employeesTableReady(false))
        this.setState({
            filter_cityId: 0,
            filter_departmetnId:0,
            filter_reportingMangerId:0
        },() => {
             this.resetPagination()
        
        this.props.dispatch(searchTextState(""))
        this.props.dispatch(employeesPriviousFilterCity(""))
        this.props.dispatch(employeesPriviousFilterDepartment(""))
        this.props.dispatch(employeesPriviousFilterReportingManager(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")

        this.getEmployeesData();
        });

    }



    expandComponent = row => {
        let row_id = ""
        if (row && row.id) {
            row_id = row.id
        }
        return <CollapsibleRow row={row} row_id={row_id} />
    }

    isExpandableRow = row => {
        return true
    }

    expandColumnComponent = ({ isExpandableRow, isExpanded }) => {
        let downIconClassName = ""
        if (isExpandableRow) {
            downIconClassName = (isExpanded ? 'fa fa-angle-double-up' : 'fa fa-angle-double-down')
        } else {
            downIconClassName = ""
        }
        return (
            <div className="custom-expandable-row-indicator">
                <span className={downIconClassName} />
            </div>
        )
    }


    renderCategory = (cell, row) => {

        let makePermanent=""

         if(false && Helpers.checkPrivileges("/dashboard/employees/addAttrition",this.props.user) && row.category==='Intern'){
            makePermanent=<div><p>{row.category}</p><PermanentEmployee data={row}/></div>
            
        }else{
            makePermanent=<p>{row.category}</p>
        }


        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{makePermanent}</div>
        </div>)


    }


    actionButtonsCreator = (cell, row) => {

        let editEmployee = ""
        let attritionEmployee=""
        let viewEmployye=""
        let editResources=""


    if(Helpers.checkPrivileges("/dashboard/employees/view",this.props.user)){
        viewEmployye=       
            <button
                title="View Employee"
                className="action-button"
                style={{ width: "30px", marginBottom: "1px",background:"green" }}
                onClick={(e) => {
                    e.preventDefault()
                    this.viewEmployee(row)
                }}>
                <i  title="View Employee" className="fa fa-eye" aria-hidden="true"></i>
            </button>

        }

        if(row.status==="ACTIVE"){
            
            if(Helpers.checkPrivileges("/dashboard/employees/addEdit",this.props.user)){

                editEmployee =       
                <button title="Edit Employee"
                    className="action-button"
                    style={{ width: "30px", marginBottom: "1px" }}
                    onClick={(e) => {
                        e.preventDefault()
                        this.editEmployee(row)
                    }}>
                    <i title="Edit Employee" className="fa fa-pencil-square-o" aria-hidden="true"></i>
                </button>
            }

                if(Helpers.checkPrivileges("/dashboard/employees/addAttrition",this.props.user)){

                    attritionEmployee =<button
                        title="Employee Attrition"
                        className="action-button btn-warning"
                        style={{ width: "30px", marginBottom: "1px", background : "red"}}
                        onClick={(e) => {
                            e.preventDefault()
                            this.addAttrition(row)
                        }}>
                        <i title="Employee Attrition" className="fa fa-trash" aria-hidden="true"></i>
                    </button>
             }
            }


                if(Helpers.checkPrivileges("/dashboard/employee/resources",this.props.user)){

                    editResources =<button
                        title="Edit Resources"
                        className="action-button btn-warning"
                        style={{ width: "30px", marginBottom: "1px", background : "blue"}}
                        onClick={(e) => {
                            e.preventDefault()
                            this.editResources(row)
                        }}>
                        <i class="fa fa-file" aria-hidden="true"></i>
                    </button>
             }

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{viewEmployye}{editEmployee}{attritionEmployee}{editResources}</div>
        </div>)
    }

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.employees && this.props.employees.previousPaginationValue
            && this.props.employees.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }

    editEmployee = (row) => {
        if (row && row.id) {
            this.props.dispatch(employeesIdForAction(row.id))
            this.props.history.push("/dashboard/employees/addEdit")
        } else {
            this.dialog.show({
                title: "Employees Identification number not found",
                body: 'Employees id is not available, So not able edit brand',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }


     addAttrition = (row) => {
        if (row && row.id) {
            this.props.dispatch(teamEmployeeIdForAction(row.id))
            this.props.dispatch(attritionSourceAction("EmployeesList"))
            this.props.history.push("/dashboard/employees/addAttrition")
        } else {
            this.dialog.show({
                title: "Employees Identification number not found",
                body: 'Employees id is not available, So not able edit brand',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }


     editResources = (row) => {
        if (row && row.id) {
            this.props.dispatch(employeeDataResourceForAction(row))
            this.props.history.push("/dashboard/employee/resources")
        } else {
            this.dialog.show({
                title: "Employees Identification number not found",
                body: 'Employees id is not available, So not able edit brand',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }

    makePermanent = (row) => {

    
    }

     viewEmployee = (row) => {
        if (row && row.id) {
            this.props.dispatch(employeesIdForAction(row.id))
            this.props.history.push("/dashboard/employees/view")
        } else {
            this.dialog.show({
                title: "Employees Identification number not found",
                body: 'Employees id is not available, So not able edit brand',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }



    
    render() {
        let sizeperPage = 15

        if (this.props.employees && this.props.employees.previousRowsPerPageValue) {
            sizeperPage = this.props.employees.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="employees-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.employeesData}
                    pagination={true}
                    expandableRow={this.isExpandableRow}
                    expandComponent={this.expandComponent}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight}}
                    expandColumnOptions={{
                        expandColumnVisible: true,
                        rerenderOnDataChange: true,
                        expandColumnComponent: this.expandColumnComponent,
                        columnWidth: 30
                    }}
                     >

                       {(() =>{

    if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
            return(     
                   <TableHeaderColumn
                        dataField="id"
                        width="60"
                        dataSort={true}
                        isKey={true}
                        expandable={false}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        ID
                    </TableHeaderColumn>

                )
            }else{
                return(

                    <TableHeaderColumn
                        dataField="id"
                        width="1"
                        isKey={true}
                        hidden={true}
                        expandable={false}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Id
                    </TableHeaderColumn>


            )
        }
})()}

                     
                    <TableHeaderColumn
                        dataField="code"dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Code
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataField="name"dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Name
                    </TableHeaderColumn>


                    <TableHeaderColumn
                        dataField="email"
                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Email
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="mobile"
                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Mobile
                    </TableHeaderColumn>
                    

                    <TableHeaderColumn
                        dataField="city_name"
                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        City
                    </TableHeaderColumn>

                     <TableHeaderColumn
                        dataField="work_location"
                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Location
                    </TableHeaderColumn>

                    
                    

                    <TableHeaderColumn
                        //dataField="category"
                        dataFormat={this.renderCategory}
                        expandable={ false }
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Category
                    </TableHeaderColumn>
                    

                    <TableHeaderColumn
                        dataField="department_name"
                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Department
                    </TableHeaderColumn>
                    

                    <TableHeaderColumn
                        dataField="designation_name"
                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Designation
                    </TableHeaderColumn>

                      <TableHeaderColumn
                        dataField="reporting_manager_name"
                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Reporting
                    </TableHeaderColumn>

                      <TableHeaderColumn
                        dataField="status"
                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Status
                    </TableHeaderColumn>

                    
                    
                     <TableHeaderColumn
                        //width="110"
                        dataField="id"
                        dataFormat={this.actionButtonsCreator}
                        filterFormatted={true}
                        width="180"
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        employees: state.employees
    }
}

export default connect(mapStateToProps)(withRouter(EmployeesTable))


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/EmployeesTable.js